import { useState, useEffect } from 'react';
import { Capacitor } from '@capacitor/core';

interface MobileBrowserDetection {
  isMobileBrowser: boolean;
  isCapacitor: boolean;
  isMobile: boolean;
}

export function useMobileBrowserDetection(): MobileBrowserDetection {
  const [detection, setDetection] = useState<MobileBrowserDetection>({
    isMobileBrowser: false,
    isCapacitor: false,
    isMobile: false,
  });

  useEffect(() => {
    const isCapacitor = Capacitor.isNativePlatform();
    
    // Detect mobile device via userAgent or screen size
    const userAgent = navigator.userAgent.toLowerCase();
    const isMobileUserAgent = /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(userAgent);
    const isMobileScreen = window.innerWidth < 768;
    const isMobile = isMobileUserAgent || isMobileScreen;
    
    // User is on mobile browser if mobile BUT NOT in Capacitor
    const isMobileBrowser = isMobile && !isCapacitor;
    
    setDetection({
      isMobileBrowser,
      isCapacitor,
      isMobile,
    });
  }, []);

  return detection;
}
